// GA追加：GA共通
export const GA_ID = 'G-KTJTTT87C5'; // 这里也替换为你的GA ID

let enentCounters = {}; // 事件计数器

const categoryMap = {
  B: 'btn_click',   // 按钮点击事件 
  M: 'mode_click',  // mode切换事件
  T: 'tab_click',   // tab切换事件
  I: 'input',       // 入力项目入力事件
  P: 'pullDown',    // 下拉菜单选择事件
  R: 'radio_click', // 单选按钮点击事件
  S: 'switch_click',// 开关按钮点击事件
};

const langKeyMap = {
  Basic: 'Simple mode',
  Advanced: 'Advanced mode',
  Search: 'Search Projector',
  Categolies: 'Categories',
  Specification: 'Specification',
  InstallCondition: 'Install condition',
  CurvedSurface: 'Curved surface',
  Blending: 'Edge Blending',
  // 国际化对应备份
  // Basic: 'T_SIMPLE_MODE',
  // Advanced: 'T_ADVANCED_MODE',
  // Search: 'T_SEARCH_MODEL',
  // Categolies: 'T_SEARCH_CATEGORY',
  // Specification: 'T_SEARCH_SPEC',
  // InstallCondition: 'T_SEARCH_CONDITION',
  // CurvedSurface: 'T_CURVE_SURFACE',
  // Blending: 'T_EDGE_BLENDING',
}

// 页面加载时生成一个新的 ID
const customSessionId = Date.now() + "_" + Math.random().toString(36).slice(2, 7);

export const getLangKey = (key) => {
  return langKeyMap[key] || '';
}

export const pageView = (url) => {
  if(window.gtag) {
    window.gtag('config', GA_ID, {
      page_path: url || '/'
    });
  }
}

// phase1 版本（按照客户提供的资料来做）
export const gaEvent = ({ action, name, value, mode=sessionStorage.getItem('mode'), tab=sessionStorage.getItem('tab') }) => {

  if (!window.gtag) return;

  if (!action) return;

  let screenName = '';

  if (!name && mode && tab) {
    name = mode + ' & ' + tab;
    screenName = name;
  }

  if (!(action == 'screen_view' || action == 'page_view')) {
    screenName = '';
  } else {
    name = '';
  }

  let searchModelVal = sessionStorage.getItem('search_m_model') || '';
  let modelName = sessionStorage.getItem('m_model_name') || '';
  let category = sessionStorage.getItem('t_category') || '';
  let lenses = modelName ? sessionStorage.getItem('LENSES') || '' : '';

  window.gtag('event', action,                       // 监听事件的事件名
    {
      screen_name: screenName || '',                 // 监听事件所在画面的画面名 (screen_name是GA里的保留参数，他只配合action是“screen_view”和“page_view”的画面统计)
      event_screen_name: name || '',                 // 监听事件所在画面的画面名 (跟上面区分开来，除上面的情况，其他时候都需要对这个自定义画面名做监听)
      event_mode: mode || '',                        // 监听事件所属mode的mode名
      event_tab: tab || '',                          // 监听事件所属tab的tab名
      event_value_1: searchModelVal,                 // 监听左侧的型番検索部分的值(只有在「型番検索」，「曲面スクリーン」和「エッジブレンディング」这3个tab下才有模糊检索的入力框，其他的tab都是清值)
      event_value_2: modelName + lenses,             // 监听右侧型番下拉框的值(所有tab用的都是一个控件)，要带镜头数据
      category: category,                            // 监听カテゴリー下拉框的值(只有在「カテゴリー別検索」tab才收集数据)
      app_name: 'throw_distance_simulator',          // 固定值设定
      test_name: 'test',                             // 测试环境和本番环境是同一个ID，为了区分是测试还是生产环境
      currency: sessionStorage.getItem('currency')   // 通过语言来过滤数据
    }
  );

  // console.log('action:'+action+';screenName:'+screenName+';name:'+name)
  // console.log(action)
  // console.log(searchModelVal)
  // console.log(modelName + lenses)
}

// 保留版本，为拓展做准备
// export const gaEvent = ({ action, name, category, label, value, mode=sessionStorage.getItem('mode'), tab=sessionStorage.getItem('tab'), shouldRecord=false }) => {

//   if (!window.gtag) return;

//   if (!action) return;

//   let screenName = '';

//   // 给每次事件生成唯一ID，防止 GA 聚合覆盖
//   const uniqueId = `${action}_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`;

//   // 默认顺序序号
//   let order = 0;
//   // 需要记录并有tab标识的才记录顺序
//   if (shouldRecord && tab) {
//     if (!enentCounters[tab]) {
//       enentCounters[tab] = 1;
//     } else {
//       enentCounters[tab]++;
//     }
//     order = enentCounters[tab];
//   }

//   if (!name && mode && tab) {
//     name = mode + ' & ' + tab;
//     screenName = name;
//   }

//   if (!(action == 'screen_view' || action == 'page_view')) {
//     screenName = '';
//   } else {
//     name = '';
//   }

//   window.gtag('event', action,                       // 监听事件的事件名
//     {
//       screen_name: screenName || '',                 // 监听事件所在画面的画面名 (screen_name是GA里的保留参数，他只配合action是“screen_view”和“page_view”的画面统计)
//       event_screen_name: name || '',                 // 监听事件所在画面的画面名 (跟上面区分开来，除上面的情况，其他时候都需要对这个自定义画面名做监听)
//       event_category: categoryMap[category] || '',   // 监听事件的事件区分 （btn_click，tab_click，input等）
//       event_label: label || '',                      // 监听事件区域对应的label名称
//       event_watch_value: value || '',                // 监听事件对应的值
//       event_mode: mode || '',                        // 监听事件所属mode的mode名
//       event_tab: tab || '',                          // 监听事件所属tab的tab名
//       event_order: order,                            // 监听事件录入的顺序序号 (暂时不用)
//       event_id: uniqueId,                            // 保证每次都是唯一的 hit (暂时不用)
//       custom_session: customSessionId,               // 每次刷新 / 新开页面都会变 (暂时不用)
//       app_name: 'throw_distance_simulator'           // 固定值设定
//     }
//   );

//   console.log('action:'+action+';screenName:'+screenName+';name:'+name)
// }
// GA追加：GA共通


// WEBPACK FOOTER //
// ./src/common/ga.js